import { inject, Injectable } from '@angular/core';

import type { ClinicStatisticsService } from '../admin/clinic-statistics.service';
import type { AdminClinicStatistics, StatisticsPeriod } from '../admin/clinic-statistics.types';
import { SupabaseService } from '../auth/supabase.service';

/**
 * Drop-in for ClinicStatisticsService on the clinic-owner routes: same JSON
 * shape, but `admin_clinic_statistics` limits it to the caller's own clinics
 * (home + assigned), so the Statistics page renders the owner's view unchanged.
 */
@Injectable()
export class OwnerClinicStatisticsService implements Pick<ClinicStatisticsService, 'getStatistics'> {
  private readonly supabase = inject(SupabaseService).client;

  async getStatistics(days: StatisticsPeriod): Promise<AdminClinicStatistics> {
    const { data, error } = await this.supabase.rpc('admin_clinic_statistics', { p_days: days });

    if (error) {
      throw error;
    }

    return data as AdminClinicStatistics;
  }
}
